<template>
    <div class="">
        <div class="custom-loader-wrapper" v-if="loader">
            <div class="text-center">
                <span class="d-block max-450">We are processing your download and this may take some time. Do not close this window until the download begins.</span>
                <img v-bind:src="$api_url+'/images/download-loader.svg'" class="loader-logo" width="100px"/>
                <p class="mt-5">Plesae click <a target="_blank" :href="$api_url+'/company/dashboard'">here</a> or below if you want to continue surfing the system.</p>
                <b-button  class="mb-1"  target="_blank"  :href="$api_url+'/company/dashboard'">Dashboard</b-button>

            </div>
        </div>
        <div class="row mt-4 no-margin">
            <div class="ibox col-md-12">
                <div class="ibox-title dashboard_title px-0">
                    <h4 class="font-regular with-blue-text">Current Selected: <span>Employee PF Profile</span></h4>
                </div>
                <div class="ibox-content px-0 trz_ppl_wrapper_2 mt-3">
                    <div v-if="custom_list.length>0">
                        <common-list  :action_btn_text="action_btn_text" :pageurl="this.$api_url"  :is_pf="is_n_pf"  :is_action="is_action" :appended_column="appended_column" :key="list_key" :company_options="company_options" :employees="custom_list" :default_column="default_column" :primary_key="primary_key" v-on:childToParent="listReturn"></common-list>
                    </div>
                    <div v-else>
                        <div v-if="showoverlay" class="list-no-data">
                            <span class="d-block text-center">Looking for relevant data..</span>
                            <img v-bind:src="$api_url+'/images/download-loader.svg'" class="loader-logo" width="100px"/>
                        </div>
                        <div v-else class="list-no-data">
                            Looks like there is no employee to show.
                        </div>
                    </div>
                </div>
                <div class="col-md-12 company-form-container-content-wrapper">
                    <div class="row mt-4 no-margin">



                    </div>
                </div>
            </div>
        </div>
        <b-modal  id="bv-modal-pf-details" hide-footer  title="Employee Profile" size="lg">
            <b-overlay rounded="sm">
                <div v-if="details.length == 0" class="px-3 py-3 no-result-cell text-center">
                    <span class="d-block text-center">{{empty_result}}</span>
                    <img v-bind:src="$api_url+'/images/download-loader.svg'" class="loader-logo" width="100px"/>
                </div>
                <div  v-else>
                <div class="clearfix border rounded mt-3  py-2 mb-2 mr-3 mb-0 col-md-12">
                        <div class="row justify-content-center">
                            {{report_data.company_name}}
                        </div>
                        <div class="row justify-content-center">
                            {{report_data.title}}
                        </div>
                    </div>
                    <div class="clearfix border rounded mt-3 mb-2 mr-3 py-2 mb-0 col-md-12">
                        <div class="row justify-content-center mb-2">
                            Employee Information
                        </div>
                        <table class="table">
                            <tr>
                                <td class="2">
                                    Employee ID
                                </td>
                                <template v-if="employee_info.employee_id!=''">
                                    <td class="2 text-left">
                                        {{employee_info.employee_id}}
                                    </td>
                                </template>
                                <template v-else>
                                    <td class="2 text-left">
                                        N/A
                                    </td>
                                </template>
                                <td class="2">
                                    PF Membership Period
                                </td>
                                <td class="2 text-left">
                                    {{employee_info.PF_membership_period}}
                                </td>
                            </tr>
                            <tr>
                                <td class="2">
                                    Employee Name
                                </td>
                                <td class="2 text-left">
                                    {{employee_info.employee_name}}
                                </td>
                                <td class="2">
                                    Service Period
                                </td>
                                <td class="2 text-left">
                                    {{employee_info.service_period}}
                                </td>
                            </tr>
                            <tr>
                                <td class="2">
                                    Job Position
                                </td>
                                <td class="2 text-left">
                                    {{employee_info.jobposition}}
                                </td>
                                <td class="2">
                                    Opening Balance Of Fund
                                </td>
                                <td class="2 text-left">
                                    {{formatMoney(details.opening_balance)}}
                                </td>
                            </tr>
                            <tr>
                                <td class="2">
                                    Joining Date
                                </td>
                                <td class="2 text-left">
                                    {{employee_info.joining_date}}
                                </td>
                                <td class="2">
                                    Closing Balance Of Fund
                                </td>
                                <td class="2 text-left">
                                    {{formatMoney(employee_info.closing_balance_of_fund)}}
                                </td>
                            </tr>
                            <tr>
                                <td class="2">
                                    PF Enrollment Date
                                </td>
                                <td class="2 text-left">
                                    {{employee_info.PF_enrollment_date}}
                                </td>
                            </tr>
                            <template v-if="employee_info.PF_leave_date!='0000-00-00'">
                                <tr>
                                    <td class="2">
                                        PF Leave Date
                                    </td>
                                    <td class="2 text-left">
                                        {{employee_info.PF_leave_date}}
                                    </td>
                                </tr>
                            </template>
                        </table>
                    </div>

                    <div class="clearfix border rounded mt-3 mr-3 px-0 mb-0 col-md-12">
                        <table class="table ">
                            <thead class="" style="">
                                <tr class="table-head" v-for="(detail, index) in details.data" :key="detail.employee_id">
                                    <template v-if="index < 1">
                                        <td class="text-center" v-for="(v,i,count) in detail">
                                            <template>
                                                {{ replaceTableHeads(i) }}
                                            </template>
                                        </td>
                                    </template>
                                </tr>
                            </thead>
                            <tbody>
                                <tr style="display: none;">
                                </tr>
                                <tr class="table-row hover-bg " v-for="detail in details.data" :key="detail.employee_id">
                                    <!--aboni 10-11-21-->
                                    <template v-for="(v,i,count) in detail">
                                        <td class="2" v-if="i == 'contribution_year' || i== 'contribution_month' || i== 'type' || i== 'Designation' || i== 'Employee Id' ||  column_selected.includes(i) ">
                                            {{v}}
                                        </td>
                                        <td v-else class="2 text-right">
                                            <div v-if="v==0">
                                                --
                                            </div>
                                            <div v-else>
                                                {{formatMoney(v)}}
                                            </div>
                                        </td>
                                    </template>
                                    <!--aboni 10-11-21-->
                                </tr>
                            </tbody>
                        </table>
                    </div>

                </div>


            </b-overlay>
        </b-modal>

    </div>
</template>

<script>


    export default{

        mounted() {
            this.$refs.trzcalendar;
        },
        props: ['pageurl' , 'flag','is_trustee'],
        components: {

        },
        data(){

            return {
                company_name: '',
                pageUrl:this.$api_url,

                search:'',
                length: 100,
                pagination: {currentPage: 1, pages:1},

                empty_result : 'Please hold tight! We are preparing the report data for you!',

                fiscal_year : '',

                payroll_reporting_data : [],
                details : [],
                showoverlay : true,
                loader: false,
                blankmsg:'Fetching data..',
                /***Ali */

                column_selected:[],
                column_options:[],
                default_fields:[],
                column_selected_view:[],
                show_selected:'',
                /**Child Component property data */
                action_btn_text:'Download Report',
                is_n_pf:1,
                action_type:0,
                is_action:0, /* As this list have actions then is_action will be 1. Otherwise it will be 0 */
                list_key:0, /* Component Key */
                em_reg_settlement_list:[],  /* Data List */
                default_column:['name','email','employee_code'], /* Default Column List */
                appended_column:[],                   /* Appended Column List  and there title and type */
                primary_key:'employee_id',  /* Primary is the unique key of the list this key will be returned if the row is clicked,
                                            for employee list is employee_id, For loan list it is loan_id etc here it is employee_id*/
                company_options:[],         /* Company Filterable options */

                custom_list:[],

                custom_array:[],

                /***Child Component property data */
                empty_result : 'Fetching Data!',
                curr_emp_pf_total:0,
                curr_emp_monthly_pf_total:{},
                pfoverlay: true,
                empdata: [],
                m_search_data: [],
                emp_pf_title: '',
                emp_btn_title: '',

                notice: "",
                blankmsg : 'Fetching data..',
                people:0,
                c_date:'',
                c_time:'',
                pf_type:0,
                curr_emp_mpf_total:{},
                pf_types: [
                    { value: "0", text: "Registered" },
                    { value: "1", text: "Unregistered" }
                ],
                action_loader: false,
                report_data:[],
                employee_info:[],
                backdoor: 0,
                length: 20,
                temp_length: 20,
                length_options: [20,30,50,100],
                pagination: {currentPage: 1,total: '',nextPage: '',prevPage: '',from: '',to: '', pages:1},



            }
        },
        methods:{
            getPFReportHeaderInfo: function(){
              axios.get(this.$api_url+'/pf/report/header')
              .then(function (response) {
                 this.company_name = response.data.company_name;
                 this.c_date = response.data.curr_date;
                 this.c_time = response.data.curr_time;
                 this.pf_type = response.data.pf_type;


              }.bind(this));

            },
            validateState(ref)
            {
                if (
                    this.veeFields[ref] &&
                    (this.veeFields[ref].dirty || this.veeFields[ref].validated)
                ) {
                    return !this.veeErrors.has(ref);
                }
                return null;
            },

            replaceTableHeads(val){
                val = val.replace(/_/g, ' ');

                val = val.toLowerCase().split(' ');
                for(var i = 0; i < val.length; i++){
                    val[i] = val[i].charAt(0).toUpperCase() + val[i].substring(1);
                }
                return val.join(' ');
            },
            getPFContributionsData: function(){
            let currentObj = this;
            this.showoverlay = true;
              axios.get(this.$api_url+'/pf/report/contributions', {
                    params: {
                    }
                }).then(function(response){
                 this.showoverlay = false;

                    /* Assingning the list */

                    /* Assingning the Options */

                    //this.tmp_custom_list = Object.keys(response.data.employee_data).map((key) => (response.data.employee_data[key]));

                    /* Now if we have actions in this grid then we have to create an additional key in each row and assing the actions for each row accordingly */

                    /* Assingning the list */
                    this.custom_list = response.data.employee_data;

                    /* Assingning the list */
                    this.custom_list = Object.keys(response.data.employee_data).map((key) => (response.data.employee_data[key]));

                    this.company_options =  response.data.options;
                    this.list_key += 1;


              }.bind(this)).catch(function (error){currentObj.showoverlay = false; currentObj.serverError(error); console.log(error)});

            },
            download_file(fileURL)
            {
                if(!this.checkNet()) return false;

                var fileName = fileURL.substring(fileURL.lastIndexOf('/')+1);
                if (!window.ActiveXObject) {
                    var save = document.createElement('a');
                    save.href = fileURL;
                    save.target = '_blank';
                    //var filename = fileURL.substring(fileURL.lastIndexOf('/')+1);
                    save.download = fileName || filename;
                    if ( navigator.userAgent.toLowerCase().match(/(ipad|iphone|safari)/) && navigator.userAgent.search("Chrome") < 0) {
                            document.location = save.href;
                        }else{
                            var evt = new MouseEvent('click', {
                                'view': window,
                                'bubbles': true,
                                'cancelable': false
                            });
                            save.dispatchEvent(evt);
                            (window.URL || window.webkitURL).revokeObjectURL(save.href);
                        }
                }
                else if ( !! window.ActiveXObject && document.execCommand)     {
                    var _window = window.open(fileURL, '_blank');
                    _window.document.close();
                    _window.document.execCommand('SaveAs', true, fileName || fileURL)
                    _window.close();
                }
            },

            stringView(str) {
                if(str == 'etin')
                {
                    return 'e-TIN';
                }
                var i, frags = str.split('_');
                for (i=0; i<frags.length; i++) {
                    frags[i] = frags[i].charAt(0).toUpperCase() + frags[i].slice(1);
                }
                return frags.join(' ');
            },
            listReturn: function(data)
            {
                if(data.trustee == 1)
                {
                    this.getEmployeePfReport(data.employee_id);
                }
            },
            pfDetailsNew: function(employee_pf)
            {
                if(employee_pf.employee_id>0){
                let currentObj = this;

                let formData = new FormData();
                formData.append('employee_id', employee_pf.employee_id);
                formData.append('viewmode', 1);
                formData.append('d_type', 'excel');
                this.pfoverlay = true;
                this.report_data = [];
                this.details = [];
                this.employee_info = [];

                axios.post(this.$api_url + '/pf/report/profile', formData)
                                    .then(function (response)
                                    {
                                        this.report_data = response.data.file_name;
                                        this.employee_info = response.data.file_name.employee_info;
                                        this.details = response.data.file_name.data;
                                        this.pfoverlay = true;
                                    }.bind(this))
                                    .catch(function (error)
                                    {
                                        console.log(error);
                                    });

                    }

                    this.$bvModal.show('bv-modal-pf-details');

            },

            getPfMonthlyTotalContribution: function(pf_cont_data)
            {

                if(pf_cont_data.length>0)
                {

                    let pf_employer_total = 0.00;
                    let pf_employee_total = 0.00;
                    let pf_profit_total = 0.00;
                    let pf_forfieture_total = 0.00;
                    let pf_loan_availed_total = 0.00;
                    let pf_loan_refund_total = 0.00;
                    let pf_settlement_total = 0.00;

                    for(let i=0; i < pf_cont_data.length; i++)
                    {

                        let pf_employer = parseFloat(this.toMoney(pf_cont_data[i].pf_employer));
                        let pf_employee = parseFloat(this.toMoney(pf_cont_data[i].pf_employee));
                        let pf_profit = parseFloat(this.toMoney(pf_cont_data[i].pf_profit));
                        let pf_forfieture = parseFloat(this.toMoney(pf_cont_data[i].pf_forfieture));
                        let pf_loan_availed = parseFloat(this.toMoney(pf_cont_data[i].pf_loan_availed));
                        let pf_loan_refund = parseFloat(this.toMoney(pf_cont_data[i].pf_loan_refund));
                        let pf_settlement = parseFloat(this.toMoney(pf_cont_data[i].pf_settlement));



                        pf_employer_total += pf_employer;
                        pf_employee_total += pf_employee;
                        pf_profit_total += pf_profit;
                        pf_forfieture_total += pf_forfieture;
                        pf_loan_availed_total += pf_loan_availed;
                        pf_loan_refund_total += pf_loan_refund;
                        pf_settlement_total += pf_settlement;

                    }


                    this.curr_emp_monthly_pf_total.pf_employer = pf_employer_total + this.curr_emp_mpf_total.pf_employer;
                    this.curr_emp_monthly_pf_total.pf_employee = pf_employee_total + this.curr_emp_mpf_total.pf_employee;
                    this.curr_emp_monthly_pf_total.pf_profit = pf_profit_total;
                    this.curr_emp_monthly_pf_total.pf_forfieture = pf_forfieture_total;
                    this.curr_emp_monthly_pf_total.pf_loan_availed = pf_loan_availed_total;
                    this.curr_emp_monthly_pf_total.pf_loan_refund = pf_loan_refund_total;
                    this.curr_emp_monthly_pf_total.pf_settlement = pf_settlement_total;

                }

            },
            getMigratedPfTotalContribution: function(mpf_cont_data)
            {
                let mpf_employer_total = 0.00;
                let mpf_employee_total = 0.00;

                if(mpf_cont_data.length>0)
                {


                        for(let i=0; i < mpf_cont_data.length; i++)
                        {

                            let mpf_employer = parseFloat(this.toMoney(mpf_cont_data[i].employer_contribution));
                            let mpf_employee = parseFloat(this.toMoney(mpf_cont_data[i].employee_contribution));

                            mpf_employer_total += mpf_employer;
                            mpf_employee_total += mpf_employee;

                        }

                }
                this.curr_emp_mpf_total.pf_employer = mpf_employer_total;
                this.curr_emp_mpf_total.pf_employee = mpf_employee_total;


            },
           formatMoney: function(amount){
                var money = Number(amount);

                if(this.$atl_company_number_format == 'no')
                {
                    money = Math.round(money);
                    money = money.toLocaleString();
                }
                else
                {
                    money = money.toLocaleString();
                    if(money=='NaN')
                    money = amount;
                    else{
                    if(money.indexOf(".")<0)
                    money = money+".00";
                    }

                }

                return money;
            },
           toMoney: function(amount)
            {
                if(amount !="0")
                {
                        if(!isNaN(amount))
                        {
                            var number = Number(amount);
                            return number;
                        }
                    var NumWithoutCommas = amount.replace(/,/g, '');
                    var number = Number(NumWithoutCommas).toFixed(2);
                    return number;
                }else
                    return amount;
            },
           getEmployeePfReport: function(employee_id)
            {
            if(employee_id>0){
                    var curr_obj = this;

                    let formData = new FormData();
                    formData.append('employee_id', employee_id);
                    formData.append('d_type', 'excel');
                    this.loader = true;
                    this.downloadBlobResponse(
                        axios.post(this.$api_url + '/pf/report/profile', formData, { responseType: 'blob' }),
                        'loader' // your loader key in this component
                    );

                }

            },
            capitalizeTheFirstLetterOfEachWord(words) {
            var separateWord = words.toLowerCase().split(' ');
            for (var i = 0; i < separateWord.length; i++) {
                separateWord[i] = separateWord[i].charAt(0).toUpperCase() +
                separateWord[i].substring(1);
            }
            return separateWord.join(' ');
            }

        },
        created: function(){
            this.getPFContributionsData();
            this.getPFReportHeaderInfo();
        },
        computed:
        {
            paginatedData()
            {
                this.backdoor;
                return this.paginate(this.custom_list, this.length, this.pagination.currentPage);
            },

        }
    }
</script>
